/* eslint-disable no-underscore-dangle */
import InlineSvg from "vue-inline-svg";
import gql from "graphql-tag";
import FeedEvents from "@/services/feed/events";
import Vue from "vue";
import { ObserveVisibility } from "vue-observe-visibility";
import FollowButton from "./TheFollowButton.vue";
import PostCaption from "./PostCaption.vue";
import ChatButtonById from "../../components/shared/chatButtonById/chatButtonById.vue";
import { mapGetters } from "vuex";
import FavoritesApi from "../../services/api/favoritesApi";
import Pusher from "pusher-js";
import Env from "../../env.js";
import PostImageWithProductCarousel from "@/views/TheDiscoveryFeed/PostImageWithProductCarousel/PostImageWithProductCarousel.vue";
import PostActions from "@/views/TheDiscoveryFeed/PostActions";
import BrandValuesList from "@/views/TheDiscoveryFeed/BrandValuesList";
import PostLink from "@/views/TheDiscoveryFeed/PostLink";

const FavoritesApiService = new FavoritesApi();

Vue.directive("observe-visibility", ObserveVisibility);

export default {
  components: {
    ChatButtonById,
    PostImageWithProductCarousel,
    InlineSvg,
    FollowButton,
    PostCaption,
    PostActions,
    PostLink,
    BrandValuesList,
  },
  apollo: {
    posts: {
      query: gql`
        query ($cursor: String!) {
          posts(sort: [CREATED_AT_DESC], first: 15, after: $cursor) {
            edges {
              node {
                id
                link
                postContent
                createdAt
                isLiked
                postType
                createdAt
                userId
                likedUsers
                likeCounts
                brand {
                  thumbnailImageUrl
                  companyName
                  id
                  values
                  vanityUrlName
                }
                media {
                  id
                  originalUrl
                  croppedUrl
                  cropParams
                  productTags
                }
              }
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
          }
        }
      `,
      variables: {
        cursor: "",
      },
    },
  },
  data() {
    return {
      isRetailer: false,
      show_create_post_button: false,
      posts: null,
      show_loader: false,
      buffered_events: [],
      feed_events: undefined,
      showFixedButton: false,
      showNewPost: false,
    };
  },
  methods: {
    checkAccess,
    fetchMorePosts,
    wantPost,
    unWantPost,
    visibilityChanged,
    viewedAPost,
    productTagsRevealed,
    productTagCTAClicked,
    messageButtonClicked,
    followButtonClicked,
    unfollowButtonClicked,
    handleScroll,
    handlebrandImageClick,
    handlebrandNameClick,
    redirectToBrandPage,
    subscribeToNewPost,
    handleNewPostClick,
    showMessageButton,
  },

  beforeMount() {
    this.isRetailer = this.$session.getUserInfo().role === "RETAILER";
    this.show_create_post_button = !this.isRetailer;

    if (this.isRetailer) {
      FavoritesApiService.getFavoriteBrands().then(({ data }) => {
        this.$store.commit("setFavoriteState", data.brand_ids);
      });
    }
  },

  created() {
    this.$data.feed_events = new FeedEvents(this);
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    this.$eventBus.$off("accessChange", this.checkAccess);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted() {
    // do a refetch if we are returning from a create post
    if (this.posts) {
      this.$apollo.queries.posts.refetch();
    }

    setTimeout(
      function () {
        this.subscribeToNewPost();
        // eslint-disable-next-line no-magic-numbers
      }.bind(this),
      3000
    );

    this.$ma.trackEvent({
      action: "Bulletin Plus Page View",
    });

    this.$eventBus.$on("accessChange", this.checkAccess);
  },

  computed: {
    isRetailerApproved() {
      return this.$store.getters.isRetailerApproved;
    },
    ...mapGetters({
      user: "userState",
      plusAccess: "plusAccessState",
    }),
  },

  watch: {
    user: function () {
      this.checkAccess();
    },
  },
};

function checkAccess() {
  if (this.user.role === "BRAND" && !this.plusAccess) {
    this.$router.replace({
      path: "/",
      query: {
        redirect: "plus",
      },
    });
  }
}

function fetchMorePosts(cursor) {
  const pos = window.scrollY;
  this.show_loader = true;
  this.$apollo.queries.posts
    .fetchMore({
      variables: {
        cursor: cursor,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        return {
          posts: {
            __typename: previousResult.posts.__typename,
            edges: [...previousResult.posts.edges, ...fetchMoreResult.posts.edges],
            pageInfo: fetchMoreResult.posts.pageInfo,
          },
        };
      },
    })
    .then(() => {
      scrollTo(0, pos);
      this.show_loader = false;
    });
}

function followButtonClicked(index) {
  const post = this.$data.posts.edges[index].node;
  this.$data.feed_events.track("FOLLOW_BRAND", post, index);
}
function unfollowButtonClicked(index) {
  const post = this.$data.posts.edges[index].node;
  this.$data.feed_events.track("UNFOLLOW_BRAND", post, index);
}

function messageButtonClicked(index) {
  const post = this.$data.posts.edges[index].node;
  this.$data.feed_events.track("MESSAGE_BRAND", post, index);
}

function productTagCTAClicked(postIndex, tagIndex) {
  const post = this.$data.posts.edges[postIndex].node,
    tag = post.media.productTags[tagIndex];

  this.$data.feed_events.track(
    "PRODUCT_TAG_CTA_CLICKED",
    {
      ...post,
      index: postIndex,
    },
    {
      tag_type: tag.tag_type,
      // eslint-disable-next-line no-prototype-builtins
      parent_category: tag.hasOwnProperty("parent_category") ? tag.parent_category : "",
    }
  );
}

function productTagsRevealed(postIndex, tagIndex) {
  const post = this.$data.posts.edges[postIndex].node,
    tag = post.media.productTags[tagIndex];

  this.$data.feed_events.track(
    "PRODUCT_TAG_VIEWED",
    {
      ...post,
      index: postIndex,
    },
    {
      tag_type: tag.tag_type,
      // eslint-disable-next-line no-prototype-builtins
      parent_category: tag.hasOwnProperty("parent_category") ? tag.parent_category : "",
    }
  );
}

function wantPost(index) {
  const post = this.$data.posts.edges[index].node;
  post.isLiked = true;

  this.$data.feed_events.track("LIKE", post, index);
}

function unWantPost(index) {
  const post = this.$data.posts.edges[index].node;
  post.isLiked = false;

  this.$data.feed_events.track("DISLIKE", post, index);
}

function viewedAPost(post, index) {
  this.$data.feed_events.track("VIEW", post, index);
}

function visibilityChanged(isVisible, elem, index) {
  if (isVisible) {
    const post = this.$data.posts.edges[index].node;
    this.viewedAPost(post, index);
  }
}
function handleScroll() {
  const scrollPXheight = 85;
  this.showFixedButton = window.scrollY > scrollPXheight;
}
function handlebrandImageClick(id) {
  this.redirectToBrandPage(id);
}
function handlebrandNameClick(id) {
  this.redirectToBrandPage(id);
}
function redirectToBrandPage(vanityUrlName) {
  this.$router.push("/brands/" + vanityUrlName);
}

function subscribeToNewPost() {
  const pusherOptions = Env.pusherOptions(),
    pusher = new Pusher(pusherOptions.key, pusherOptions.options);

  pusher.connection.bind("error", function (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  });
  pusher.subscribe("public-bulletinplus");
  pusher.bind("new-post", () => {
    this.showNewPost = true;
  });
}

function handleNewPostClick() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  this.$apollo.queries.posts.refetch();
  this.showNewPost = false;
}

/* eslint-disable camelcase */
function showMessageButton(post) {
  const { role, brand_id } = this.user;

  return this.user && role !== "ADMIN" && brand_id !== post.node.brand.id;
}
